import { Application } from '@hotwired/stimulus';
var application = Application.start();
application.debug = false;
window.Stimulus = application;
export default application;